import { useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { IoIosMenu } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import Logo from "../../assets/logo.svg";
import LogoImage from "../../assets/Hlogo.svg";
import { CgFacebook } from "react-icons/cg";
import { ImTwitter } from "react-icons/im";
import { FaInstagram } from "react-icons/fa";
import { useState } from "react";
import {
  Wrap,
  SideMessage,
  SocialMediaIcon,
  ContactNav,
  BurgerNav,
  BurgerLogo,
  CustomClose,
} from "../betaForm/BetaSubmitForm.styles";
import BetaForm from "../betaForm/BetaForm";
import PaydayDetail from "./PaydayDetail";

const PaydayForm = ({
  formTitle = "Payday Credit Registration Form",
  title = "Payday Credit",
  description = "You have taken an amazing first step, we can’t wait to be a part of your journey to success.",
}) => {
  const [status, setStatus] = useState(false);
  const [step, setStep] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Wrap>
        <SideMessage>
          <div>
            <div className="contact__menu">
              <Link to="/">
                {" "}
                <img src={LogoImage} alt="company_logo" />
              </Link>
              <div className="menu__icon" onClick={() => setStatus(true)}>
                <IoIosMenu size={40} />
              </div>
            </div>
            <h1 className="header__title">{title}</h1>
            <p className="description">{description}</p>
            <div className="footer__details">
              <SocialMediaIcon>
                <Link to="/">
                  <CgFacebook color="#fff" size={23} />
                </Link>
                <Link to="/">
                  <ImTwitter color="#fff" size={23} />
                </Link>
                <Link to="/">
                  {" "}
                  <FaInstagram color="#fff" size={23} />
                </Link>
              </SocialMediaIcon>
              <p>© Copyright 2021 Invest-Trust Limited. All Rights Reserved.</p>
            </div>
          </div>
        </SideMessage>
        <div className="contact__form">
          <ContactNav>
            <div>
              <NavLink to="/">Home</NavLink>
              <NavLink to="/about">About Us</NavLink>
              <NavLink to="/product">Our Products</NavLink>
              {/* <NavLink to="/">Media</NavLink> */}
              <NavLink to="/contact">Contact</NavLink>
            </div>
          </ContactNav>
          <BurgerNav show={status}>
            <CustomClose
              onClick={() => {
                setStatus(false);
              }}
            >
              <IoMdClose size={30} />
            </CustomClose>
            <div>
              <BurgerLogo>
                <Link to="/">
                  <img src={Logo} alt="company_logo" />
                </Link>
              </BurgerLogo>
              <NavLink to="/">Home</NavLink>
              <NavLink to="/about">About Us</NavLink>
              <NavLink to="/product">Our Products</NavLink>
              <NavLink to="/contact">Contact</NavLink>
            </div>
          </BurgerNav>
          <h1>{formTitle}</h1>
          <div className="form__nav">
            <span
              className={step === 1 ? "activeStep" : "step"}
              onClick={() => setStep(1)}
            >
              Profile Information
            </span>
            <span></span>
            <span
              className={step === 2 ? "activeStep" : "step"}
              onClick={() => setStep(2)}
            >
              Details
            </span>
          </div>
          <div>
            {step === 1 && <BetaForm />}
            {step === 2 && <PaydayDetail />}
          </div>
        </div>
      </Wrap>
    </>
  );
};

export default PaydayForm; 
